/**
 * Created by laszlo.czondor on 2017. 11. 07.
 */
import Cookies from 'js-cookie';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

export default {
	data() {
		return {
			isVisible: false
		}
	},
	methods: {
		closeNotification(isAccepted) {
			this.isVisible = false;
			if (isAccepted) {
				Cookies.set(this.cookieName, true, {expires: this.cookieLifeSpanInDays});
			}
		}
	},
	props: {
		cookieName: {
			type: String,
			required: true
		},
		cookieLifeSpanInDays: {
			type: Number,
			default: 365 // one year
		}
	},
	mounted() {
		let cookie = Cookies.get(this.cookieName);
		this.isVisible = !cookie;
	}
}



// WEBPACK FOOTER //
// ../source/common/cookie-notification/cookie-notification.js